import { Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { SafeUrlPipe } from '../../../pipes/safe-url.pipe';
import { FileViewerService } from './file-viewer.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-file-viewer',
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    NgxExtendedPdfViewerModule,
    SafeUrlPipe
  ],
  templateUrl: './file-viewer.component.html',
  styleUrls: ['./file-viewer.component.css']
})
export class FileViewerComponent implements OnDestroy {
  isVisible = false;
  viewerUrl: string | null = null;
  viewerType: 'pdf' | 'image' | 'office' | 'unsupported' | null = null;
  private subscription: Subscription;

  constructor(private fileViewerService: FileViewerService) {
    this.subscription = this.fileViewerService.viewerState$.subscribe(state => {
      this.isVisible = state.isVisible;
      this.viewerUrl = state.url;
      this.viewerType = state.type;
    });
  }

  onClose() {
    this.fileViewerService.hide();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
